<div class="outer-container" *ngIf="loadComplete">
    <!-- Toast Container - positioned at top level -->
    <div *ngIf="showToast" class="toast-container">
        <div [ngClass]="['toast-message', toastType === 'success' ? 'toast-success' : 'toast-error']">
            <div class="toast-content">
                <div class="toast-text">
                    <div class="toast-title" *ngIf="toastTitle">{{ toastTitle }}</div>
                    <div class="toast-message-text">{{ toastMessageText }}</div>
                </div>
                <span class="material-symbols-outlined f-24 cursor-pointer" id="manage_profile_toast_close"
                tabindex="0"
                (click)="closeToast()" 
                (keypress)="closeToast()"
                title="Close">close</span>
            </div>
        </div>
    </div>

    <!-- Identity Panel -->
    <div class="row ml-0 mr-0">
        <div class="panel-blue">
            <div class="header" (click)="togglePanel('identity', showIdentity ? 'up' : 'down')" tabindex="0" role="button" aria-expanded="{{showIdentity}}" aria-controls="identityPanel" aria-label="Identity Information section, toggle to expand/collapse">
                <span class="panel-title">Identity Information</span>
                <button class="toggle-panel" 
                      *ngIf="showIdentity" 
                      id="up_identityPanel_btn" 
                      type="button"
                      (click)="togglePanel('identity', 'up'); $event.stopPropagation()"
                      (keydown.enter)="togglePanel('identity', 'up'); $event.preventDefault()"
                      (keydown.space)="togglePanel('identity', 'up'); $event.preventDefault()"
                      tabindex="0"
                      aria-expanded="true"
                      aria-controls="identityPanel"
                      aria-label="Identity Information section, toggle to collapse">
                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                    <span class="sr-only">Collapse</span>
                </button>
                <button class="toggle-panel" 
                      *ngIf="!showIdentity" 
                      id="down_identityPanel_btn" 
                      type="button"
                      (click)="togglePanel('identity', 'down'); $event.stopPropagation()"
                      (keydown.enter)="togglePanel('identity', 'down'); $event.preventDefault()"
                      (keydown.space)="togglePanel('identity', 'down'); $event.preventDefault()"
                      tabindex="0"
                      aria-expanded="false"
                      aria-controls="identityPanel"
                      aria-label="Identity Information section, toggle to expand">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    <span class="sr-only">Expand</span>
                </button>
            </div>
            <div class="panel-body" id="identityPanel" *ngIf="showIdentity">
                <div class="row ml-0 mr-0">
                    <div class="col-sm-12 col-md-6 col-lg-3">
                        <label for="firstName">First Name</label>
                        <input autofocus tabindex="0" type="text" id="firstName" name="firstName"
                        [(ngModel)]="profile.firstName" class="form-control" disabled/>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3">
                        <label for="middleName">Middle Name</label>
                        <input autofocus tabindex="0" type="text" id="middleName"
                        [(ngModel)]="profile.middleName" class="form-control" disabled/>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3">
                        <label for="lastName">Last Name</label>
                        <input autofocus tabindex="0" type="text" id="lastName"
                        [(ngModel)]="profile.lastName" class="form-control" disabled/>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3">
                        <label for="suffix">Suffix</label>
                        <input autofocus tabindex="0" type="text" id="suffix" class="form-control" [value]="suffixValue" disabled/>
                    </div>
                </div>
                <div class="row">
                    &nbsp;
                </div>
                <form [formGroup]="manageProfileForm" novalidate>
                <div class="row ml-0 mr-0">
                    
                    <div class="col-sm-12 col-md-6 col-lg-3">
                        <label for="inputfield_manage_profile_dob">Date of Birth <!-- <span class="requiredfield text-danger">*</span> --></label>
                        <input autofocus tabindex="0" id="inputfield_manage_profile_dob" type="text" id="dob"  class="form-control" [value]="dobValue" disabled/>
                        <span class="ssn-itin" >
                            <button class="btn p-0" tabindex="0" aria-label="Show Calendar" id="showCaldendar"><img src="../../../../assets/images/neveda-images/Calendar.svg" alt="Calendar"></button>
                        </span>
                    </div>
                    
                    <!-- ITIN Section -->
                    <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="!profile.ssn && (profile.itin || ITINDetected)">
                    <label for="inputfield_manage_profile_itin">
                        ITIN
                        <span class="tooltip-icon tooltip-container" (mouseenter)=openITINooltip() (mouseleave)=closeITINTooltip()>
                            <button class="material-symbols-outlined f-16" (click)=toggleITINooltip($event)>info</button>
                            <span *ngIf="showITINTooltip" class="material-symbols-outlined inverted-arrow">arrow_drop_down</span>
                            <div *ngIf="showITINTooltip" class="tooltip-box">
                                <div class="ssn-tooltip-polygon"></div>
                                <div class="email-tooltip-frame" (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                                    Individual Taxpayer Identification Number
                                </div>
                            </div>
                        </span>
                    </label>

                    <div class="input-group ssn-input-group">
                        <input
                            type="text"
                            id="inputfield_manage_profile_itin"
                            class="formField"
                            formControlName="itin"
                            ssnMask
                            toggleMask
                            [maskType]="'ITIN'"
                            (input)="onITINInput($event)"
                            (maskBlur)="onMaskBlur($event)"
                            maxlength="11"
                            autocomplete="off"
                            aria-required="true"
                            [disabled]="!isLegacyUser && existingDisabledCondition"
                            [attr.aria-invalid]="manageProfileForm.get('itin')?.invalid ? 'true' : null"
                            [attr.aria-describedby]="manageProfileForm.get('itin')?.invalid ? 'itin-error' : null"
                            [ngClass]="{'is-invalid': manageProfileForm.get('itin')?.invalid && manageProfileForm.get('itin')?.touched}"
                            placeholder="Enter ITIN"
                        />
                    </div>
                    </div>
                    
                    <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="!SSNDetected && ITINDetected">
                        <label>Have you received a Social Security Number?
                            <span class="requiredfield text-danger">*</span>
                        </label>
                        <div>
                            <input
                                type="radio"
                                id="radiofield_manage_profile_received_ssn_yes"
                                formControlName="receivedSSN"
                                [value]="true"
                                class="mr-1"
                            />
                            <label for="radiofield_manage_profile_received_ssn_yes" class="mr-2">Yes</label>

                            <input
                                type="radio"
                                id="radiofield_manage_profile_received_ssn_no"
                                formControlName="receivedSSN"
                                [value]="false"
                                class="mr-1"
                            />
                            <label for="radiofield_manage_profile_received_ssn_no">No</label>
                        </div>
                        <div *ngIf="manageProfileForm.get('receivedSSN')?.invalid && manageProfileForm.get('receivedSSN')?.touched" class="text-danger mt-1 err-font">
                           {{ errorMessage['M0013'] }}
                        </div>
                    </div>


                    <!-- SSN Section -->
                    <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="SSNDetected || manageProfileForm.get('receivedSSN')?.value === true">
                    <label for="inputfield_manage_profile_ssn">
                        SSN<span *ngIf="!SSNDetected && ITINDetected" class="requiredfield text-danger">*</span>
                         <span class="tooltip-icon tooltip-container" (mouseenter)=openSSNTooltip() (mouseleave)=closeSSNTooltip()>
                            <button class="material-symbols-outlined f-16" (click)=toggleSSNTooltip($event)>info</button>
                            <span *ngIf="showSSNTooltip" class="material-symbols-outlined inverted-arrow">arrow_drop_down</span>
                            <div *ngIf="showSSNTooltip" class="tooltip-box">
                                <div class="ssn-tooltip-polygon"></div>
                                <div class="email-tooltip-frame" (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                                    Social Security Number
                                </div>
                            </div>
                        </span>
                    </label>
                    <div class="input-group ssn-input-group">
                        <input
                            type="text"
                            id="inputfield_manage_profile_ssn"
                            class="form-control ssn-input"
                            aria-required="true"
                            [attr.aria-invalid]="(manageProfileForm.get('ssn')?.touched && manageProfileForm.get('ssn')?.invalid) || ssnExists ? 'true' : null"
                            [attr.aria-describedby]="(manageProfileForm.get('ssn')?.touched && manageProfileForm.get('ssn')?.invalid) || ssnExists ? 'ssn-error' : null"
                            formControlName="ssn"
                            tabindex="0"
                            placeholder="Enter SSN"
                            maxlength="11"
                            autocomplete="off"
                            numbersOnly ssnMask toggleMask
                            [maskType]="'SSN'"
                            (input)="onSSNInput($event)"
                            (maskBlur)="onMaskBlur($event)"
                            [ngClass]="{
                            'is-invalid': (manageProfileForm.get('ssn')?.touched && manageProfileForm.get('ssn')?.invalid) || (ssnExists && !isSSNFocused)
                            }"
                        />
                    </div>

                        <!-- Form validation errors -->
                        <div *ngIf="manageProfileForm.get('ssn')?.touched && manageProfileForm.get('ssn')?.errors as errors">
                        <div id="ssn-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">
                            {{ errorMessage['M0011'] }} <!-- Please enter your SSN -->
                        </div>
                        <div id="ssn-error" *ngIf="!errors['required'] && errors['pattern']" class="text-danger mt-1 err-font">
                            {{ errorMessage['M0012'] }} <!-- Please enter a valid SSN -->
                        </div>
                        <div id="ssn-error" *ngIf="!errors['required'] && !errors['pattern'] && errors['ssnInvalid']" class="text-danger mt-1 err-font">
                            {{ errorMessage['M0013'] }}
                        </div>
                        </div>
                    </div>
                    
                </div>
                </form>
            </div>
        </div>
    </div>
    <!-- Identity Panel -->

    <!-- Contact Information Panel -->
    <div class="row ml-0 mr-0">
        <div class="panel-blue">
            <div class="header" (click)="togglePanel('contact', showContact ? 'up' : 'down')" tabindex="0" role="button" aria-expanded="{{showContact}}" aria-controls="contactPanel" aria-label="Contact Information section, toggle to expand/collapse">
                <span class="panel-title">Contact Information</span>
                <button class="toggle-panel" 
                      *ngIf="showContact" 
                      id="contactUp" 
                      type="button"
                      (click)="togglePanel('contact', 'up'); $event.stopPropagation()"
                      (keydown.enter)="togglePanel('contact', 'up'); $event.preventDefault()"
                      (keydown.space)="togglePanel('contact', 'up'); $event.preventDefault()"
                      tabindex="0"
                      aria-expanded="true"
                      aria-controls="contactPanel"
                      aria-label="Contact Information section, toggle to collapse">
                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                    <span class="sr-only">Collapse</span>
                </button>
                <button class="toggle-panel" 
                      *ngIf="!showContact" 
                      id="contactDown" 
                      type="button"
                      (click)="togglePanel('contact', 'down'); $event.stopPropagation()"
                      (keydown.enter)="togglePanel('contact', 'down'); $event.preventDefault()"
                      (keydown.space)="togglePanel('contact', 'down'); $event.preventDefault()"
                      tabindex="0"
                      aria-expanded="false"
                      aria-controls="contactPanel"
                      aria-label="Contact Information section, toggle to expand">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    <span class="sr-only">Expand</span>
                </button>
            </div>
            <div class="panel-body" id="contactPanel" *ngIf="showContact">
                <div class="row mr-0 ml-0">
                    <div class="col-sm-12 col-md-6 col-lg-4 mb-2">
                        <label for="email">
                            Primary Email<span class="requiredfield text-danger">*</span>
                            <span class="tooltip-icon tooltip-container" (mouseenter)=openEmailooltip() (mouseleave)=closeEmailTooltip()>
                                <button type="button" class="material-symbols-outlined f-16" (click)=toggleEmailTooltip($event)>info</button>
                                <span *ngIf="emailTooltip" class="material-symbols-outlined inverted-arrow">arrow_drop_down</span>
                                <div *ngIf="emailTooltip" class="tooltip-box">
                                    <div class="ssn-tooltip-polygon"></div>
                                    <div class="email-tooltip-frame" (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                                    {{genericMessage['G0002']}}
                                    </div>
                                </div>
                            </span>
                        </label>
                        <input autofocus tabindex="0" type="email" id="email"  class="formField" placeholder="Enter Email Address" [(ngModel)]="profile.email" (ngModelChange)="updatedFlag = hasFormChanged()" readonly/>
                        <span class="icon-holder" >
                            <button class="btn p-0" tabindex="0"  (click)="openEditModal('primaryEmail')"
                             title="Edit Email" aria-label="Edit" id="showEditEmail"><img src="../../../../assets/images/neveda-images/Edit.svg" alt="Edit" srcset=""></button>
                        </span>
                         <div role="alert" *ngIf="!profile.email || profile.email.trim() === ''" class="text-danger mt-1 err-font">{{ errorMessage['M0014'] }}</div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4">
                        <label for="recovery_email">
                            Recovery Email
                            <span class="tooltip-icon tooltip-container" (mouseenter)=openRecoveryEmailooltip() (mouseleave)=closeRecoveryEmailTooltip()>
                                <button class="material-symbols-outlined f-16" (click)=toggleRecoveryEmailTooltip($event)>info</button>
                                <span *ngIf="recoveryEmailTooltip" class="material-symbols-outlined inverted-arrow">arrow_drop_down</span>
                                <div *ngIf="recoveryEmailTooltip" class="tooltip-box">
                                    <div class="ssn-tooltip-polygon"></div>
                                    <div class="email-tooltip-frame" (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                                    {{genericMessage['G0002']}}
                                    </div>
                                </div>
                            </span>
                        </label>
                        <input autofocus tabindex="0" type="email" id="recovery_email"  class="formField" placeholder="Enter Recovery Email Address" [(ngModel)]="profile.recovery_email" (ngModelChange)="updatedFlag = hasFormChanged()" readonly/>
                        <span class="icon-holder" >
                            <button class="btn p-0" tabindex="0"  (click)="openEditModal('recoveryEmail')"
                             title="Edit Email" aria-label="Edit" id="showEditEmail"> <img src="../../../../assets/images/neveda-images/Edit.svg" alt="Edit" srcset=""></button>
                        </span>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4" *ngIf="viewport==='large'">
                        <label for="phoneNumber">Phone Number<span class="requiredfield text-danger">*</span></label>
                        <input autofocus tabindex="0" type="tel" id="phoneNumber"  class="formField" placeholder="Enter Phone Number" [(ngModel)]="profile.phoneNumber" (ngModelChange)="updatedFlag = hasFormChanged()" readonly/>
                        <span class="icon-holder" >
                            <button class="btn p-0" tabindex="0"  (click)="openEditModal('phoneNumber')"
                             title="Edit Phone Number" aria-label="Edit" id="showEditEmail"> <img src="../../../../assets/images/neveda-images/Edit.svg" alt="" srcset=""></button>
                        </span>
                         <div role="alert" *ngIf="!profile.phoneNumber || profile.phoneNumber.trim() === ''" class="text-danger mt-1 err-font">{{ errorMessage['M0016'] }}</div>
                    </div>
                </div>
                <div class="row">
                    &nbsp;
                </div>
                <div class="row  ml-0 mr-0">
                    <div class="col-sm-12 col-md-6 col-lg-4" *ngIf="viewport==='medium' || viewport==='small'">
                        <label for="phoneNumber">Phone Number<span class="requiredfield text-danger">*</span></label>
                        <input autofocus tabindex="0" type="tel" id="phoneNumber"  class="formField" placeholder="Enter Phone Number" [(ngModel)]="profile.phoneNumber" (ngModelChange)="updatedFlag = hasFormChanged()" readonly/>
                        <span class="icon-holder" >
                            <button class="btn p-0" tabindex="0"  (click)="openEditModal('phoneNumber')"
                             title="Edit Phone Number" aria-label="Edit" id="showEditEmail"><img src="../../../../assets/images/neveda-images/Edit.svg" alt="Edit"></button>
                        </span>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4">
                        <label for="phoneNumber">Alternate Phone Number</label>
                        <input autofocus tabindex="0" type="tel" id="altPhoneNumber" placeholder="Enter Phone Number" class="form-control ssn-input" [(ngModel)]="profile.alternate_phone" (ngModelChange)="updatedFlag = hasFormChanged()" readonly/>
                        <!-- <span class="icon-holder" >
                            <button class="btn p-0 pencil pi pi-pencil" tabindex="0"  (click)="openEditModal('phoneNumber')"
                             title="Edit Email" aria-label="Show/hide SSN" id="showEditEmail"></button>
                        </span> -->
                        <!-- <span class="icon-holder" >
                            <button class="btn p-0" tabindex="0"  (click)="openEditModal('altPhoneNumber')"
                             title="Edit Alternate Phone Number" aria-label="Edit" id="showEditEmail"><img src="../../../../assets/images/neveda-images/Edit.svg" alt="Edit"></button>
                        </span> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Contact Information Panel -->

    <!-- Demographic Panel -->
    <div class="row  ml-0 mr-0">
        <div class="panel-blue">
            <div class="header" (click)="togglePanel('demographic', showDemographic ? 'up' : 'down')" tabindex="0" role="button" aria-expanded="{{showDemographic}}" aria-controls="demographicPanel" aria-label="Demographics section, toggle to expand/collapse">
                <span class="panel-title">Demographics</span>
                <button class="toggle-panel" 
                      *ngIf="showDemographic" 
                      id="demographicUp" 
                      type="button"
                      (click)="togglePanel('demographic', 'up'); $event.stopPropagation()"
                      (keydown.enter)="togglePanel('demographic', 'up'); $event.preventDefault()"
                      (keydown.space)="togglePanel('demographic', 'up'); $event.preventDefault()"
                      tabindex="0"
                      aria-expanded="true"
                      aria-controls="demographicPanel"
                      aria-label="Demographics section, toggle to collapse">
                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                    <span class="sr-only">Collapse</span>
                </button>
                <button class="toggle-panel" 
                      *ngIf="!showDemographic" 
                      id="demographicDown" 
                      type="button"
                      (click)="togglePanel('demographic', 'down'); $event.stopPropagation()"
                      (keydown.enter)="togglePanel('demographic', 'down'); $event.preventDefault()"
                      (keydown.space)="togglePanel('demographic', 'down'); $event.preventDefault()"
                      tabindex="0"
                      aria-expanded="false"
                      aria-controls="demographicPanel"
                      aria-label="Demographics section, toggle to expand">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    <span class="sr-only">Expand</span>
                </button>
            </div>
            <div class="panel-body" id="demographicPanel" *ngIf="showDemographic">
                <div class="row ml-0 mr-0">
                    <div class="col-sm-12 col-md-6 col-lg-4 relPos">
                        <label for="gender">Gender<span class="requiredfield text-danger">*</span></label>
                        <select id="gender" [value]="profile.gender"  class="formField" (change)="profile.gender=$event.target.value; updatedFlag = hasFormChanged();" aria-label="Gender">
                            <option *ngIf="profile.gender===''" value="" disabled selected>Select Gender</option>
                            <option *ngFor="let list of genderList" [value]="list.key">{{ list.value }}</option>
                        </select>
                        <span class="clearHolder">
                        <button
                        *ngIf="profile.gender!==''"
                        type="button"
                        class="clear-icon"
                        tabindex="-1"
                        (click)="profile.gender=''; updatedFlag = hasFormChanged(); $event.stopPropagation()"
                        aria-label="Clear selection">
                        &#10006;
                        </button>
                        </span>
                        <div role="alert" *ngIf="profile.gender===''" class="text-danger mt-1 err-font">{{ errorMessage['M0006'] }}</div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4 relPos">
                        <label for="race">Race<span class="requiredfield text-danger">*</span></label>
                        <select id="race" [value]="profile.race" class="formField" (change)="profile.race=$event.target.value; updatedFlag = hasFormChanged();" aria-label="Race">
                            <option *ngIf="profile.race===''" value="" disabled selected>Select Race</option>
                            <option *ngFor="let list of raceList" [value]="list.key">{{ list.value }}</option>
                        </select>
                        <span class="clearHolder">
                        <button
                        *ngIf="profile.race!==''"
                        type="button"
                        class="clear-icon"
                        tabindex="-1"
                        (click)="profile.race=''; updatedFlag = hasFormChanged(); $event.stopPropagation()"
                        aria-label="Clear selection">
                        &#10006;
                        </button>
                        </span>
                        <div role="alert" *ngIf="profile.race===''" class="text-danger mt-1 err-font">{{ errorMessage['M0007'] }}</div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4 relPos">
                        <label for="ethinicity">Ethnicity<span class="requiredfield text-danger">*</span></label>
                        <select id="ethinicity" [value]="profile.ethinicity" class="formField" (change)="profile.ethinicity=$event.target.value; updatedFlag = hasFormChanged();" aria-label="Ethnicity">
                            <option *ngIf="profile.ethinicity===''" value="" disabled selected>Select Ethnicity</option>
                            <option *ngFor="let list of ethinicityList" [value]="list.key">{{ list.value }}</option>
                        </select>
                        <span class="clearHolder">
                        <button
                        *ngIf="profile.ethinicity!==''"
                        type="button"
                        class="clear-icon"
                        tabindex="-1"
                        (click)="profile.ethinicity=''; updatedFlag = hasFormChanged(); $event.stopPropagation()"
                        aria-label="Clear selection">
                        &#10006;
                        </button>
                        </span>
                        <div role="alert" *ngIf="profile.ethinicity===''" class="text-danger mt-1 err-font">{{ errorMessage['M0008'] }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Demographic Panel -->

        <!-- <div class="row">
            <div class="rowSeparator">&nbsp;</div>
        </div> -->

        <div class="row mb-3 fullWidth ml-0 mr-0 row">
            <div class="col text-right border-top mt-20 pt-3 pr-0 manage-action">
                <button id="btn_manageProfile_reset" class="btn btn-outline-secondary" (click)="resetProfile()">Reset</button>
                <button id="btn_manageProfile_update" class="btn btn-primary" (click)="onSubmit()" [disabled]="isSaveDisabled">{{saveText}}</button>
            </div>
        </div>
    </div>
</div>